import { enUS } from "../../../../date-fns/locale/en-US.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    enUS
  }
};